<template>
  <div id="ErrorConfig-edit">
    <IForm ref="formInline" :model="edit" :elem="errorElem" :rules="errorRule" :label-width="125" :submit="false"  @on-submit="toSubmit">
      <div>
        <!-- 左边内容区 -->
        <Row>
          <Col span="9">
            <Row>
              <Col span="24">
                <FormItem label="名称" prop="name" required><Input v-model="edit.name" type="text" placeholder="请输入名称" maxlength="50"/></FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="24">
                <FormItem label="适用性别" prop="gender">
                  <RadioGroup prop="gender" v-model="edit.gender">
                    <Radio v-for="item in genderList" v-bind:key="item.code" :label="item.code" @dblclick.native.prevent="()=>{edit.gender = null}">{{item.name}}</Radio>
                  </RadioGroup>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="24">
                <FormItem label="适用年龄">
                  <Row>
                    <Col span="11"><Input v-model="edit.startAge" type="number" placeholder="请输入开始年龄" maxlength="2"/></Col>
                    <Col span="2" style="text-align: center">~</Col>
                    <Col span="11"><Input v-model="edit.endAge" type="number" placeholder="请输入结束年龄" maxlength="2"/></Col>
                  </Row>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="24">
                <FormItem label="适用既往病史">
                  <MyCheckBox :enumList="pastMedicalHistoryList" :ignore-list="['1']" :dataList.sync="pastMedicalHistorys" :dataStr.sync="edit.pastMedicalHistory"/>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="24">
                <FormItem label="适用过敏史">
                  <RadioGroup v-model="edit.allergyHistory">
                    <Radio v-for="item in allergyHistoryList" v-bind:key="item.code" :label="item.code" @dblclick.native.prevent="()=>{edit.other = null}">{{item.value}}</Radio>
                  </RadioGroup>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="24">
                <FormItem label="适用传染病接触史">
                  <RadioGroup v-model="edit.infectionHistory">
                    <Radio v-for="item in infectionHistoryList" v-bind:key="item.code"  :label="item.code" @dblclick.native.prevent="()=>{edit.other = null}">{{item.value}}</Radio>
                  </RadioGroup>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="24">
                <FormItem label="健康评价" prop="evaluation" required>
                  <Input v-model="edit.evaluation" type="textarea" placeholder="请输入健康评价" :rows="2" maxlength="100"/>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="24">
                <FormItem>
                  <RadioGroup prop="gender" v-model="edit.showError">
                    <Radio v-for="item in showErrorList" v-bind:key="item.code" :label="item.code" @dblclick.native.prevent="()=>{edit.showError = null}">{{item.value}}</Radio>
                  </RadioGroup>
<!--                  <MyCheckBox :enumList="showErrorList" :dataList.sync="showErrors" :dataStr.sync="edit.showError"/>-->
                  <div style="color:#f3673d;font-size: 14px;" v-if="edit.showError==1">模版：血压偏低</div>
                  <div style="color:#f3673d;font-size: 14px;" v-if="edit.showError==2">模版：血压偏低:舒张压 22mmhg</div>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="24">
                <FormItem label="异常原因" prop="reason">
                  <Input v-model="edit.reason" type="textarea" placeholder="请输入异常原因" :rows="3" maxlength="200" show-word-limit/>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="24">
                <FormItem label="意见建议" prop="propose">
                  <Input v-model="edit.propose" type="textarea" placeholder="请输入意见建议" :rows="5" maxlength="500" show-word-limit/>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="24">
                <FormItem label="转诊建议">
                  <el-switch v-model="edit.referral" :inactive-value="1" :active-value="2"/>
                </FormItem>
              </Col>
            </Row>
            <Row v-if="edit.referral === 2">
              <Col span="24">
                <FormItem label="转诊原因" prop="referralReason" :required="edit.referral && edit.referral === 2">
                  <Input v-model="edit.referralReason" type="textarea" placeholder="请输入转诊原因" :rows="2" maxlength="100" show-word-limit/>
                </FormItem>
              </Col>
            </Row>
            <Row v-if="edit.referral === 2">
              <Col span="24">
                <FormItem label="转诊机构" prop="referralInstitutionId" :required="edit.referral && edit.referral === 2">
                  <Select v-model="edit.referralInstitutionId">
                    <Option v-for="item in referralInstitutions" :value="item.id" v-bind:key="item.id">{{ item.name }}</Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <Row v-if="edit.referral === 2">
              <Col span="24">
                <FormItem label="转诊科室" prop="referralDepartmentId" :required="edit.referral && edit.referral === 2">
                  <Select v-model="edit.referralDepartmentId">
                    <Option v-for="item in referralDepartments" :value="item.id" v-bind:key="item.id">{{ item.name }}</Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>
          </Col>
          <Col span="15">
            <Row>
              <Col span="12">
                <FormItem label="条件">
                  <Select v-model="edit.logicalCondition">
                    <Option v-for="item in conditionList" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="1"/>
              <Col span="11">
                <el-row>
                  <el-button size="small" type="primary" @click="onAdd">添加</el-button>
                  <el-button size="small" type="danger" @click="onClear">清空</el-button>
                </el-row>
              </Col>
            </Row>
            <Row v-for="(item, index) in this.edit.conditions" style="margin-bottom: 10px;">
              <Col span="2"/>
              <Col span="5">
                <el-select v-model="item.fieldId" placeholder="请选择" filterable size="small" transfer="true" :popper-append-to-body="false">
                  <el-option v-for="fieldItem in fields" :key="fieldItem.fieldId"
                             :label="fieldItem.fieldName + (fieldItem.label != item.alias ? '[' + item.alias + ']' : '')"
                             :value="fieldItem.fieldId" @click.native="onField(fieldItem, item)" style="width: 100%;z-index: 9999;">
                    <span style="float: left">{{ fieldItem.fieldName + (fieldItem.label != item.alias ? '[' + item.alias + ']' : '') }}</span>
                    <span :style="{'float':'right','color':convertBusinessType(fieldItem.businessType).color,'font-size':'13px'}">{{ convertBusinessType(fieldItem.businessType).name }}</span>
                  </el-option>
                </el-select>
              </Col>
              <Col span="1"/>
              <Col span="3">
                <Select v-model="item.conditionSymbolId" placeholder="条件">
                  <Option v-for="symbolItem in item.symbols" :value="symbolItem.conditionSymbolId" v-bind:key="symbolItem.conditionSymbolId">{{ symbolItem.label }}</Option>
                </Select>
              </Col>
              <Col span="1"/>
              <Col span="8">
                <Input v-model="item.conditionValue" type="text" placeholder="请输入" v-if="item.elementType===1||item.elementType===2||item.elementType===3||item.elementType===15"/>
<!--                <MyCascader v-model="item.conditionValue" :options="item.treeOptions" placeholder="请选择" v-else-if="item.elementType===10||item.elementType===11"-->
<!--                            :multiple="false" :display="''" @on-change="value=>changeCascader(value, item)"/>-->

                <el-cascader v-model="item.conditionValue" size="small" placeholder="请选择" :options="item.treeOptions"  v-else-if="item.elementType===10||item.elementType===11"
                            @change="value=>changeCascader(value, item)"/>

                <Select v-model="item.conditionValue" placeholder="请选择" v-else>
                  <Option v-for="symbolItem in item.options" :value="symbolItem.id" v-bind:key="symbolItem.id">{{ symbolItem.name }}</Option>
                </Select>
              </Col>
              <Col span="1"/>
              <Col span="3">
                <el-row>
                  <el-button size="small" type="danger" @click="onDelete(index)">删除</el-button>
                </el-row>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </IForm>

  </div>
</template>
<script>
import {_get, _save, _baseData} from "@/services/screeningConfig/errorConfig.js";
import {_fieldConfigList} from "@/services/screeningConfig/fieldConfig"
export default {
  name: "ErrorConfigEdit",
  data() {
    return {
      edit: {
        name: "",
        gender: "",
        startAge: "",
        endAge: "",
        pastMedicalHistory: "",
        allergyHistory: "",
        infectionHistory: "",
        evaluation: "",
        showError: "",
        referral:"",
        referralReason:"",
        referralInstitutionId:"",
        referralDepartmentId:"",
        logicalCondition:2,
        status:1,
        conditions:[],
      },
      genderList:[
        {name: '男', code: 1},
        {name: '女', code: 2},
      ],
      pastMedicalHistoryList:[
        {value: '无', code: "1"},
        {value: '先天性心脏病', code: "2"},
        {value: '癫痫', code: "3"},
        {value: '高热惊厥', code: "4"},
        {value: '哮喘', code: "5"},
        {value: 'G-6PD缺陷病', code: "6"},
        {value: '其他', code: "7"},
      ],
      allergyHistoryList:[
        {value: '无', code: 1},
        {value: '有', code: 2}
      ],
      infectionHistoryList:[
        {value: '无', code: 1},
        {value: '有', code: 2}
      ],
      showErrorList:[
        {value: '显示异常检查项', code: "1"},
        {value: '显示异常数据', code: "2"},
      ],
      conditionList:[
        {label: '满足所有条件', value: 1},
        {label: '满足任意一项条件', value: 2},
      ],
      init:"",
      pastMedicalHistorys:[],
      fields:[],
      elementSymbols:[],
      referralInstitutions:[],
      referralDepartments:[],
      showErrors:[],
      errorElem:[],
      errorRule: {
        name: [
          {required: true, message: '名称不能为空'},
          {maxlength:50,message:"名称长度不能超过50个字"}
        ],
        evaluation: [
          {required: true, message: '健康评价不能为空'},
          {maxlength:300,message:"健康评价长度不能超过300个字"}
        ],
        referralReason: [
          {validator:function(rule, value, callback){
              if (this.edit.referral && this.edit.referral === 2) {
                callback(new Error('转诊原因价不能为空'));
              } else {
                callback();
              }
            }.bind(this), trigger: 'input' }
        ],
        referralInstitutionId: [
          {validator:function(rule, value, callback){
              if (this.edit.referral && this.edit.referral === 2) {
                callback(new Error('请选择转诊机构'));
              } else {
                callback();
              }
            }.bind(this), trigger: 'input' }
        ],
        referralDepartmentId: [
          {validator:function(rule, value, callback){
              if (this.edit.referral && this.edit.referral === 2) {
                callback(new Error('请选择转诊科室'));
              } else {
                callback();
              }
            }.bind(this), trigger: 'input' }
        ],
      },
    };
  },
  mounted() {
    this.init = Object.assign({}, this.edit);
  },
  methods: {
    convertBusinessType(businessType){
      if(businessType == 1){
        return {color:'#16B94E',name:"通用"};
      }else if(businessType == 2){
        return {color:'#BDAE0C',name:"幼儿园"};
      }else if(businessType == 3){
        return {color:'#BF7007',name:"小学"}
      }else if(businessType == 4){
        return {color:'#006DFD',name:"中学"}
      }else if(businessType == 5){
        return {color:'#CE1616',name:"大学"};
      }
    },
    onAdd(){
      this.edit.conditions.push({fieldId:"", conditionSymbolId:"", conditionValue:""});
    },
    onClear(){
      this.edit.conditions = [];
    },
    onField(item, conditionItem){
      conditionItem.elementType = item.elementType;
      conditionItem.options = item.options;
      conditionItem.conditionValue = "";
      conditionItem.symbols = [];
      conditionItem.options = [];
      conditionItem.treeOptions = [];
      let elementSymbol = this.elementSymbols.find(e => e.elementType === item.elementType);
      if(elementSymbol && elementSymbol.symbols && elementSymbol.symbols.length > 0){
        conditionItem.symbols = elementSymbol.symbols;
      }

      conditionItem.treeOptions = this.converTreeOptions(item.treeOptions);
      this.$forceUpdate();
    },
    converTreeOptions(treeOptions){
      let options = [];
      if (treeOptions) {
        treeOptions.forEach(field => {
          let childs = [];
          let option = {label: field.name, value: field.id}
          if (field.children && field.children.length > 0) {
            field.children.forEach(child => {
              if (child.isShow === 1) {
                childs.push({label: child.name, value: child.id})
              }
            })
            option.children = childs;
          }
          options.push(option)
        })
      }
      return options;
    },
    changeCascader(value, conditionItem){
      conditionItem.conditionValue = value.join(",");
    },
    fieldConfigList(){
      this.fields = [];
      _fieldConfigList().then(res =>{
        if (res.errcode === 1) {
          this.fields = res.data;
        }
      })
    },
    baseData(){
      this.elementSymbols = [];
      this.referralInstitutions = [];
      this.referralDepartments = [];
      _baseData().then(res =>{
        if (res.errcode === 1 && res.data) {
          this.elementSymbols = res.data.elementSymbols;
          this.referralInstitutions = res.data.referralInstitutions;
          this.referralDepartments = res.data.referralDepartments;
        }
      })
    },
    onDelete(index){
      this.edit.conditions.splice(index, 1)
    },
    handleModal(row) {
      this.fieldConfigList();
      this.baseData();

      this.$refs["formInline"].handleReset();
      if (!row) {
        this.onClear();
        this.handleCreate();
      } else {
        this.handleEdit(row);
      }
      this.$forceUpdate();
    },
    handleCreate() {
      this.resetForm();
    },
    convertConditionValue(value, condition){
      let newValue = [];
      let treeOptions = [];

      if (value && value.length > 0 && condition.treeOptions){
        let dataArr = value.split(",");
        condition.treeOptions.forEach(option =>{
          let childs = [];
          let treeOption = {label: option.name, value: option.id}

          let correct = dataArr.find(item=> item === option.id);
          if (correct){
            newValue.push(correct)
          }

          if (option.children && option.children.length > 0) {
            option.children.forEach(child=>{
              if (child.isShow === 1) {
                childs.push({label: child.name, value: child.id})
              }

              let correctChild = dataArr.find(item=> item === child.id);
              if (correctChild){
                newValue.push(correctChild)
              }
            })
            treeOption.children = childs;
          }
          treeOptions.push(treeOption)
        })
      }
      condition.treeOptions = treeOptions;

      return newValue;
    },
    handleEdit(row) {
      let _this = this;
      _get({id: row.id}).then(res =>{
        if (res.errcode === 1) {
          if(res.data.conditions && res.data.conditions.length > 0){
            res.data.conditions.forEach(condition=>{
              if(condition.elementType===10||condition.elementType===11){
                condition.conditionValue = _this.convertConditionValue(condition.conditionValue, condition);
              }
            });
          }

          this.edit = Object.assign({}, res.data);
          this.$forceUpdate();
        }
      })
    },
    handleSubmit() {
      this.$refs["formInline"].handleSubmit('form');
    },
    toSubmit() {
      if(this.edit.conditions && this.edit.conditions.length > 0){
        this.edit.conditions.forEach(condition=>{
          if((condition.elementType===10||condition.elementType===11)&&Array.isArray(condition.conditionValue)){
            condition.conditionValue = condition.conditionValue.join(",");
          }
          delete condition.symbols;
          delete condition.options;
          delete condition.treeOptions;
        });
      }

      _save(this.edit).then(res => {
        if (res.errcode === 1) {
          this.taskProjects = [];
          this.$message.success("保存成功");
          this.$emit("on-submit", false);
        } else {
          this.$message.error(res.errmsg);
        }
      }).catch(() => {});
    },
    resetForm() {
      this.edit = {
        name: "",
        gender: "",
        startAge: "",
        endAge: "",
        pastMedicalHistory: "",
        allergyHistory: "",
        infectionHistory: "",
        evaluation: "",
        showError: "",
        referral:"",
        referralReason:"",
        referralInstitutionId:"",
        referralDepartmentId:"",
        logicalCondition:2,
        status:1,
        conditions:[],
      }
    }
  }
};
</script>
<style lang="postcss" scoped>
::v-deep(.el-cascader .el-input__inner) {height: 33px;line-height: 33px;}
/deep/ .ivu-form-item-content {position: relative;line-height: 25px;font-size: 14px;}
</style>
